import React from 'react';
import MUIDataTable from 'mui-datatables';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Button } from '@mui/material';
import { ExitToApp as ExitToAppIcon } from '@mui/icons-material';
import { getRoleAssignment } from '../helpers/getters';
import { Roles } from '../models/roles';

const RescuerRoleAssignmentsTable = ({ roleAssignments, onDeleteRoleAssignmentButtonClick, title = 'Sites' }) => {
  const getMuiTheme = (theme) =>
    createTheme({
      ...theme,
      components: {
        ...theme.components,
        MuiTableCell: {
          styleOverrides: {
            root: {
              ...theme.components.MuiTableCell.styleOverrides.root,
              padding: '4px 4px 4px 12px',
              '@media (max-width: 600px)': {
                '&:last-child': {
                  borderBottom: 'solid 2px rgba(0, 0, 0, 0.2) !important',
                },
              },
            },
          },
        },
        MuiTableRow: {
          styleOverrides: {
            head: {
              ...theme.components.MuiTableRow.styleOverrides.root,
              height: '36px',
            },
          },
        },
        MUIDataTableHeadCell: {
          styleOverrides: {
            root: {
              ...theme.components.MUIDataTableHeadCell.styleOverrides.root,
              padding: '4px 4px 4px 12px',
            },
          },
        },
      },
    });

  return (
    <ThemeProvider theme={getMuiTheme}>
      <MUIDataTable
        title={title}
        data={roleAssignments}
        columns={[
          {
            name: 'role_name',
            label: 'Role',
            options: {
              filter: false,
              sort: false,
            },
          },
          {
            name: 'assignment',
            label: 'Assignment',
            options: {
              filter: false,
              sort: false,
              customBodyRenderLite: dataIndex => {
                const roleAssignment = roleAssignments[dataIndex];
                return getRoleAssignment(roleAssignment);
              },
            },
          },
          {
            name: 'actions',
            label: 'Actions',
            options: {
              download: false,
              filter: false,
              sort: false,
              customBodyRenderLite: dataIndex => {
                const roleRow = roleAssignments[dataIndex];
                const sitesWithRescuerRoles = roleAssignments.filter(row => row.role_name === Roles.Rescuer);

                if (roleRow.role_name !== Roles.Rescuer) {
                  return null;
                }

                return (
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    disabled={sitesWithRescuerRoles.length <= 1}
                    onClick={() => onDeleteRoleAssignmentButtonClick(roleRow)}
                    startIcon={<ExitToAppIcon />}
                  >
                    Leave Site
                  </Button>
                );
              },
            },
          },
        ]}
        options={{
          responsive: 'simple',
          selectableRows: 'none',
          pagination: false,
          search: false,
          filter: false,
          download: false,
          print: false,
          viewColumns: false,
        }}
      />
    </ThemeProvider>
  );
};

export default RescuerRoleAssignmentsTable;
